import React, {Dispatch, SetStateAction} from 'react'
import {useQuery} from 'react-query'
import {Link, useParams} from 'react-router-dom'
import {getResponseFromInterviewIdDatewise} from '../_requests'
import {format} from 'date-fns'

const ResponseListDatewise = ({
  date,
  setView,
}: {
  date: string
  setView: Dispatch<SetStateAction<'' | 'grouped' | 'all'>>
}) => {
  const {id} = useParams()

  const {data, isLoading} = useQuery({
    queryKey: ['responses', id],
    queryFn: () => getResponseFromInterviewIdDatewise(id),
  })

  return (
    <div className={`card mt-8 ${date === '' ? 'd-none' : ''}`}>
      <div className='card-header'>
        <h3 className='card-title'>Responses</h3>
      </div>
      <div className='card-body'>
        {isLoading ? (
          <div className='d-flex align-items-center justify-center'>
            <div className='loader'></div>
          </div>
        ) : (
          <>
            {data && data.length > 0 ? (
              <div className='table-responsive min-h-500px'>
                <table className='table table-row-dashed table-row-gray-200 align-middle'>
                  <thead className='bg-light'>
                    <tr className='fw-bold text-muted'>
                      <th className='ps-4 min-w-150px'>Date</th>
                      <th className='text-center min-w-100px'>Responses</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={item._id ?? index}>
                        <td className='ps-4 fw-semibold text-gray-800'>
                          <Link to={`/reports/${id}/${item._id}`} onClick={() => setView('')}>
                            {item?._id ? format(new Date(item._id), 'dd/MM/yyyy') : 'N/A'}
                          </Link>
                        </td>
                        <td className='text-center fw-bold text-gray-900'>{item?.count ?? 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className='d-flex flex-column align-items-center justify-content-center min-h-200px text-muted'>
                <span className='fs-6'>No responses found for the selected interview.</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ResponseListDatewise
